import { IApplicationState, TFilterId } from '../../../../../../../../types/types';
import { createDeepEqualSelector } from '../../../../../../helpers/memoizeHelper';
import { MY_WORK_FILTER_BOARD_ID } from '../../../../../../aside_panel/filterPanelBoard/constants';
import {
    getPinnedSavedFiltersIds
} from '../../../../../../aside_panel/filterPanelBoard/components/SavedSection/hocs/selectors/getPinnedSavedFiltersIds';

type TgetMtWorkPinnedFilterIds = (
    state: IApplicationState,
) => TFilterId[];

export const getMyWorkPinnedFilterIdsCreateSelector = (
): TgetMtWorkPinnedFilterIds => createDeepEqualSelector(
    (state: IApplicationState) => getPinnedSavedFiltersIds(state, MY_WORK_FILTER_BOARD_ID),
    filterIds => filterIds
);
